import { create } from 'zustand'
import type { CartItemProps } from '@/@types/cart'

import { actionGetCartItems } from '@/lib/actions/cartActions'


interface CartStore {
    items?: CartItemProps[]
    selectedItems?: CartItemProps[]
    countItems?: number
    setSelectedItems?: (items: CartItemProps[]) => void
    clearSelectedItems?: () => void
     setItems: (items: CartItemProps[]) => void
    clear: () => void
    addItem: (item: CartItemProps) => void
    removeItem: (id: string) => void
    loadItems: () => Promise<void>
}


export const useCartStore = create<CartStore>((set, get) => ({
    selectedItems: [],
    setSelectedItems: (items) => set({ selectedItems: items }),
    clearSelectedItems: () => set({ selectedItems: [] }),

    items: [],
    countItems: 0,

    setItems: (items) => set({ 
        items,
        countItems: items.reduce(
      (sum, i) => sum + i.quantity,
      0
    ),
        // countItems: items.length,
    }),

    clear: () => set({ items: [], countItems: 0 }),
    addItem: (item) => {
        const items = [...get().items, item]
        set({ items, countItems: items.length })
    },

    removeItem: (id) => {
        const items = get().items.filter(i => i.id !== id)
        set({ items, countItems: items.length })
    },

    loadItems: async () => {
        try {
            const data = await actionGetCartItems() // уже JSON!
            set({ items: data.items ?? [], countItems: data.items?.length ?? 0 })
        } catch (err) {
            console.error('Ошибка загрузки корзины:', err)
        }
    }

}))
